module.exports = __webpack_public_path__ + "static/media/rank-10-guru.a2c92e4a.svg";